import React, { lazy } from "react";
import { Base_Url } from "../../utils/apiUrl";

const LiveMatrix = lazy(() => import("../../pages/WarrantTools/LiveMatrix"));
const WarrantSearch = lazy(() => import("../../pages/WarrantTools/WarrantSearch"));
const WarrantTerms = lazy(() => import("../../pages/WarrantTools/WarrantTerms"));
const WarrantCalculator = lazy(() => import("../../pages/WarrantTools/warrantCalculator"));
const Exposuresimulator = lazy(() => import("../../pages/WarrantTools/WarrantHedgingTool"));
const WarrantUnderLyingChart = lazy(() => import("../../pages/WarrantTools/WarrantUnderLyingChart"));
const WarrantComparison = lazy(() => import("../../pages/WarrantTools/WarrantComparison"));
const WarrantDocument = lazy(() => import("../../pages/WarrantTools/WarrantDocument"));
const WarrantHeatmap = lazy(() => import("../../pages/WarrantTools/WarrantHeatmap"));


const warrantToolRoutes = [
  {
    path: "/tools/livematrix/",
    element: <LiveMatrix />,
    title: "Live Matrix Plus | Malaysia Warrants | Macquarie",
    description: "Use our live matrix to make trading warrants easy. See where our bid prices for index and single stock structured warrants will be throughout the day.",
    keyword: "Live matrix, live pricing, bid price",
    ogUrl: `${Base_Url}/tools/livematrix/tools/livematrix`,
    ogType: "website",
    ogTitle: "Live Matrix Plus",
    ogDescription: "See where a warrant's bid and offer price will be",
    ogImage: `${Base_Url}/tools/livematrix/img/home/Meta%20Image%20(Op1)_V2-80.jpg`,
    facebookDomain: "",
  },
  {
    path: "/tools/livematrix/:ric_id",
    element: <LiveMatrix />,
    title: "Live Matrix Plus | Malaysia Warrants | Macquarie",
    description: "Use our live matrix to make trading warrants.",
    keyword: "Live matrix, live pricing, bid price",
    ogUrl: `${Base_Url}/tools/livematrix/tools/livematrix`,
    ogType: "website",
    ogTitle: "Live Matrix Plus",
    ogDescription: "See where a warrant's bid and offer price will be",
    ogImage: `${Base_Url}/tools/livematrix/img/home/Meta%20Image%20(Op1)_V2-80.jpg`,
    facebookDomain: "",
  },
  {
    path: "/tools/warrantsearch",
    element: <WarrantSearch />,
    title: "Warrant search | Malaysia Warrants | Macquarie",
    description: "Use our warrant search tool to find all structured warrants that match your investment criteria to aid in your decision-making.",
    keyword: "warrant search, investment criteria, malaysia warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/tools/warrantsearch/:id",
    element: <WarrantSearch />,
    title: "Warrant search | Malaysia Warrants | Macquarie",
    description: "Use our warrant search tool to find all structured warrants that match your investment criteria to aid in your decision-making.",
    keyword: "warrant search, investment criteria, malaysia warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/tools/warrantterms",
    element: <WarrantTerms />,
    title: "Warrant terms | Malaysia Warrants | Macquarie",
    description: "Find out more about your selected structured warrant by viewing all warrant terms here.",
    keyword: "warrant terms, Macquarie, malaysia warrants",
  },
  {
    path: "/tools/warrantterms/:id",
    element: <WarrantTerms />,
    title: "Warrant terms | Malaysia Warrants | Macquarie",
    description: "Find out more about your selected structured warrant by viewing all warrant terms here.",
    keyword: "warrant terms, Macquarie, malaysia warrants",
  },
  {
    path: "/tools/exposuresimulator",
    element: <Exposuresimulator />,
    title: "Exposure Simulator | Malaysia Warrants | Macquarie",
    description: "Use our warrant calculator to estimate your future structured warrant price given a change in underlying price, time to expiry or implied volatility.",
    keyword: "Exposure Simulator,  Macquarie, malaysia warrants",
  },
  {
    path: "/tools/exposuresimulator/:id",
    element: <Exposuresimulator />,
    title: "Exposure Simulator | Malaysia Warrants | Macquarie",
    description: "Use our warrant calculator to estimate your future structured warrant price given a change in underlying price, time to expiry or implied volatility.",
    keyword: "Exposure Simulator,  Macquarie, malaysia warrants",
  },
  {
    path: "/tools/warrantcalculator",
    element: <WarrantCalculator />,
    title: "Warrant calculator | Malaysia Warrants | Macquarie",
    description: "Use our warrant calculator to estimate your future structured warrant price given a change in underlying price, time to expiry or implied volatility.",
    keyword: "warrant calculator,  Macquarie, malaysia warrants",
  },
  {
    path: "/tools/warrantcalculator/:id",
    element: <WarrantCalculator />,
    title: "Warrant calculator | Malaysia Warrants | Macquarie",
    description: "Use our warrant calculator to estimate your future structured warrant price given a change in underlying price, time to expiry or implied volatility.",
    keyword: "warrant calculator,  Macquarie, malaysia warrants",
  },
  {
    path: "/tools/underlying",
    element: <WarrantUnderLyingChart />,
    title: "Underlying charts | Malaysia Warrants |  Macquarie",
    description: "Use underlying charts to perform technical analysis on a warrant's underlying. See the underlying's traded volume and technical indicators in one click.",
    keyword: "underlying charts, technical analysis, traded volume",
  },
  {
    path: "/tools/underlying/:id",
    element: <WarrantUnderLyingChart />,
    title: "Underlying charts | Malaysia Warrants |  Macquarie",
    description: "Use underlying charts to perform technical analysis on a warrant's underlying. See the underlying's traded volume and technical indicators in one click.",
    keyword: "underlying charts, technical analysis, traded volume",
  },
  {
    path: "/tools/warrantcomparison",
    element: <WarrantComparison />,
    title: "Warrant Comparison | Malaysia Warrants | Macquarie",
    description: "Compare multiple warrants and their key factors at one glance for faster and more optimal decision-making.",
    keyword: "warrant comparison, malaysia warrants, Macquarie",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/tools/document",
    element: <WarrantDocument />,
    title: "Warrant documents | Malaysia Warrants | Macquarie",
    description: "Gain access to all of Macquarie's listing documents, prospectus, and terms and conditions relevant to structured warrants issued by Macquarie.",
    keyword: "listing, prospectus, term sheets",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/tools/heatmap",
    element: <WarrantHeatmap />,
    title: "Warrant Heatmap | Malaysia Warrants | Macquarie",
    description: "The warrant heatmap shows you whether an underlying is bullish or bearish, based on TradeVSA's proprietary algorithm. View charts, associated warrants and more.",
    keyword: "Warrant heatmap, TradeVSA, technical analysis, technical chart",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/tools/heatmap/:id",
    element: <WarrantHeatmap />,
    title: "Warrant Heatmap | Malaysia Warrants | Macquarie",
    description: "The warrant heatmap shows you whether an underlying is bullish or bearish, based on TradeVSA's proprietary algorithm. View charts, associated warrants and more.",
    keyword: "Warrant heatmap, TradeVSA, technical analysis, technical chart",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
];

export default warrantToolRoutes;
